function safeDownloadFilename(value, fallback, extension) {
  const basename = String(value || '')
    .normalize('NFC')
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001f\u007f/\\:*?"<>|]+/g, '_')
    .replace(/^\.+|\.+$/g, '')
    .trim()
  return `${basename || fallback}.${extension}`
}

export {
  safeDownloadFilename,
}
